import {useEffect} from "react";
import store from 'storejs';
import {useDispatch, useSelector} from "react-redux";
import {selectLecturers, selectLoading, selectProgram} from "../Reducers/ProgramReducer";
import {fetchProgram} from "../Functions/fetchProgram";

export const useFetchProgram = () => {
    const dispatch = useDispatch()
    const lecturers = useSelector(selectLecturers)
    const program = useSelector(selectProgram)
    const loading = useSelector(selectLoading)

    useEffect(() => {
        dispatch(fetchProgram());
    }, [dispatch])

    useEffect(()=>{
        store({lecturers});
        store({program});
    },[lecturers, program])

    return {
        loading: loading,
        lecturers,
        program
    }
}
